export enum References {
  FORCE_CLOSE = -1,
  OPENED_ACTIVE = 0,
  ASSOCIADO_ASSEMBLEIAS = 1,
}
